<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "mineHome",
    components: {
    },
    data() {
        return {

        }
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>